import { DirectAffiliateCodes } from "@/constants/affiliateCode"
import { QuoteVariant } from "@/lib/flags/feature-flags.shared"
import { type OnboardingFormValues } from "../wizard"

function isOctopusDirectFunnel(formValues: OnboardingFormValues) {
    return !!formValues.affiliateCode && DirectAffiliateCodes.includes(formValues.affiliateCode)
}

export function isFastQuoteJourney(formValues: OnboardingFormValues) {
    return (
        isOctopusDirectFunnel(formValues) &&
        formValues.featureFlags.quoteVariant !== QuoteVariant.HighInput
    )
}

export function isCustomizableQuote(formValues: OnboardingFormValues) {
    return (
        isOctopusDirectFunnel(formValues) &&
        formValues.featureFlags.quoteVariant === QuoteVariant.LowInputCustomizable
    )
}
